export const API_VARIABLE_NAME_PATTERN = /^[a-z][a-z0-9_]{0,39}$/;
export const FIXED_API_VARIABLES = [
    { name: 'name', title: 'Name' },
    { name: 'company', title: 'Company' },
    { name: 'email', title: 'Email' },
    { name: 'phone', title: 'Phone' },
    { name: 'notes', title: 'Notes' },
];
const reservedNames = new Set([
    ...FIXED_API_VARIABLES.map(({ name }) => name),
    'department',
    'dialog_id',
    'is_connected',
    'is_maximized',
    'language',
    'max',
    'page_title',
    'page_url',
    'send_message',
    'show',
    'size',
    'status',
    'texts',
    'trigger',
]);
export function isReservedApiVariableName(name) {
    return reservedNames.has(name);
}
export function normaliseApiVariableDefinitions(definitions) {
    const seen = new Set();
    const result = [];
    for (const definition of definitions ?? []) {
        const name = definition.name.trim().toLowerCase();
        const title = definition.title.trim().slice(0, 80);
        if (!title ||
            !API_VARIABLE_NAME_PATTERN.test(name) ||
            isReservedApiVariableName(name) ||
            seen.has(name))
            continue;
        seen.add(name);
        result.push({ name, title });
        if (result.length === 50)
            break;
    }
    return result;
}
export function normaliseApiVariableValue(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return undefined;
    const candidate = value;
    if (typeof candidate.value !== 'string')
        return undefined;
    const normalisedValue = candidate.value.trim().slice(0, 500);
    if (!normalisedValue)
        return undefined;
    if (candidate.url === undefined)
        return { value: normalisedValue };
    if (typeof candidate.url !== 'string')
        return undefined;
    try {
        const url = new URL(candidate.url);
        if (!['http:', 'https:'].includes(url.protocol))
            return undefined;
        const normalisedUrl = url.toString();
        if (normalisedUrl.length > 2048)
            return undefined;
        return { url: normalisedUrl, value: normalisedValue };
    }
    catch {
        return undefined;
    }
}
export function apiVariableValuesForDefinitions(value, definitions) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return {};
    const stored = value;
    return Object.fromEntries(definitions.flatMap(({ name }) => {
        const normalised = normaliseApiVariableValue(stored[name]);
        return normalised ? [[name, normalised]] : [];
    }));
}
//# sourceMappingURL=api-variables.js.map